import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';
import { useApp } from '../context/AppContext';
import Sidebar from './Sidebar';
import './Home.css';
import useAuth from '../hooks/useAuth';

const Home = () => {
  const navigate = useNavigate();
  const { 
    user, 
    selectedCountry, 
    setSelectedCountry, 
    countries,
    topics,
    selectedTopic,
    setSelectedTopic,
    fetchCountries,
    fetchTopics,
  } = useApp();
  const [userMessage, setUserMessage] = useState('');
  const fetchedRef = useRef(false);

  useAuth(); // This handles all authentication and redirects

  useEffect(() => {
    if (!fetchedRef.currentC) {
      fetchCountries();
      fetchedRef.currentC = true;
    }
  }, [fetchCountries]);

  useEffect(() => {
    if (!fetchedRef.currentT) {
      fetchTopics();
      fetchedRef.currentT = true;
    }
  }, [fetchTopics]);

  const handleCountryChange = async (e) => {
    setSelectedCountry(e.target.value);
  };

  const handleTopicChange = async (e) => {
    setSelectedTopic(e.target.value);
  };

  const handleSendMessage = async () => {
    if (userMessage.trim()) {
      navigate('/dialog', { 
        state: { 
          initialMessage: userMessage,
          selectedTopic,
          selectedCountry
        } 
      });
    }
  };

  return (
    <div className="page-container">
      <Sidebar />
      
      <div className="main-content">
        <div className="question-window">
          <h1 className="question-title">What would you like to ask COLA?</h1>
          
          <div className="country-selection">
            <label className="select-label">Select Country</label>
            <select 
              className="select-dropdown" 
              value={selectedCountry || ''}
              onChange={handleCountryChange}
            >
              <option value="">Select a country</option>
              {countries.map(country => (
                <option key={country.id} value={country.id}>
                  {country.name}
                </option>
              ))}
            </select>
          </div>
          
          <div className="topic-selection">
            <label className="select-label">Select Topic</label>
            <select 
              className="select-dropdown" 
              value={selectedTopic || ''}
              onChange={handleTopicChange}
              // disabled={!selectedCountry}
            >
              <option value="">Select a topic</option>
              {topics.map(topic => (
                <option key={topic.id} value={topic.id}>
                  {topic.name}
                </option>
              ))}
            </select>
          </div>
          
          <textarea 
            className="message-input" 
            placeholder="Type your question here..."
            value={userMessage}
            onChange={(e) => setUserMessage(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                handleSendMessage();
              }
            }}
          ></textarea>
          
          <button 
            className="enter-button"
            onClick={handleSendMessage}
            disabled={!userMessage.trim()}
          >
            Enter
          </button>
        </div>
      </div>
    </div>
  );
};

export default Home;
